import React, {useState} from 'react';
import {Button, Modal} from "react-bootstrap";
import {Link} from "react-router-dom";
import {Portlet, PortletBody, PortletHeader} from "../../../../components/Portlet";
import ApiSelect from "../../../base/components/forms/apiSelect";
import {CounterpartiesCreateContacts} from "../../../routesConstants";
import BlockUi from "@availity/block-ui";
import axios from "../../../../helpers/axios";

const hasCardMatch = (item) =>
  (item.clients || []).some(client => (client.matchedBy || []).includes('card'));

const ClientLink = ({client}) => (
  <Link
    to={"/counterparty/contacts?id=" + client.id}
    target={'_blank'}
    className={'link-info text-decoration-underline'}
  >
    {client.lastName} {client.firstName}
  </Link>
);

const MileCards = ({mileCards}) => {
  const [hiddenCards, setHiddenCards] = useState([]);
  const [show, setShow] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const [selectedClientId, setSelectedClientId] = useState();
  const [mileCardForModal, setMileCardForModal] = useState();
  const [loading, setLoading] = useState(false);

  const itemsWithCard = (mileCards || []).filter(item => item.mileCard);
  const matchedByCardItems = itemsWithCard.filter(hasCardMatch);
  const cardsToCheck = itemsWithCard.filter(item =>
    item.needToCheck &&
    !hasCardMatch(item) &&
    !hiddenCards.some(hidden => hidden.fullNumber === item.mileCard.fullNumber)
  );
  const collapsedItems = [
    ...matchedByCardItems.map(item => ({
      fullNumber: item.mileCard.fullNumber,
      clients: (item.clients || []).filter(client => (client.matchedBy || []).includes('card'))
    })),
    ...hiddenCards.filter(hidden =>
      !matchedByCardItems.some(item => item.mileCard.fullNumber === hidden.fullNumber)
    )
  ];

  const addMileCard = (client, mileCard) => {
    setLoading(true);
    const payload = {
      cardNumber: mileCard.fullNumber,
      airline: mileCard.airline?.id
    };
    axios.post("/api/counterparty/contacts/addMileCard/" + client.id, payload)
      .then(() => {
        setHiddenCards(prev => [...prev, {
          fullNumber: mileCard.fullNumber,
          clients: [client]
        }]);
      })
      .finally(() => setLoading(false));
  };

  if (!cardsToCheck.length && !collapsedItems.length) {
    return null;
  }

  const openOtherModal = (mileCard) => {
    setMileCardForModal(mileCard);
    setSelectedClientId();
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setSelectedClientId();
    setMileCardForModal();
  };

  const saveOther = () => {
    if (!selectedClientId || !mileCardForModal) {
      return;
    }
    addMileCard({id: selectedClientId}, mileCardForModal);
    handleClose();
  };

  const renderCollapsed = () => collapsedItems.map((item, index) => (
    <div key={item.fullNumber + index} className={'mb-2'}>
      <div className={'font-weight-bold border-bottom pb-2 mb-2'}>
        <b>{item.fullNumber}</b>
      </div>
      {(item.clients || []).map(client => (
        <div key={client.id} className={'mb-2'}>
          <ClientLink client={client}/>
        </div>
      ))}
      {index !== collapsedItems.length - 1 && <hr/>}
    </div>
  ));

  return (
    <BlockUi blocking={loading}>
      <Portlet>
        <PortletHeader title={'Мильные карты'}/>
        <PortletBody>
          {cardsToCheck.map((item, index) => {
            const {mileCard, clients = []} = item;
            return (
              <div key={index}>
                <div className={'font-weight-bold border-bottom pb-2 mb-2'}>
                  <b>{mileCard.fullNumber}</b>
                </div>
                {clients.length > 0 && clients.map(client => (
                  <div key={client.id} className={'mb-2'}>
                    <ClientLink client={client}/>
                    <div className={'d-flex gap-2 flex-wrap mt-1'}>
                      <Button size={'sm'} onClick={() => addMileCard(client, mileCard)}>
                        Добавить этому
                      </Button>
                      <Button size={'sm'} variant={'outline-primary'} onClick={() => openOtherModal(mileCard)}>
                        Добавить другому
                      </Button>
                    </div>
                  </div>
                ))}
                {clients.length === 0 && <Button size={'sm'} variant={'outline-primary'} onClick={() => openOtherModal(mileCard)}>
                  Выбрать клиента
                </Button>}
                {index !== cardsToCheck.length - 1 && <hr/>}
              </div>
            );
          })}
          {!cardsToCheck.length && collapsedItems.length > 0 && (
            <>
              <div
                className={'link-info text-decoration-underline'}
                style={{cursor: 'pointer', display: showAll ? 'none' : 'block'}}
                onClick={() => setShowAll(true)}
              >
                Не требуют проверки
              </div>
              {showAll && renderCollapsed()}
            </>
          )}
        </PortletBody>
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Добавить карту другому клиенту</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className={'text-center'}>
              <div style={{minWidth: '20rem', marginBottom: 4}}>
                <ApiSelect
                  value={selectedClientId}
                  label={'Клиент'}
                  url={"/api/counterparty/contacts/searchInput"}
                  cb={newVal => {
                    setSelectedClientId(newVal);
                  }}
                />
              </div>
              Или
              <div className={'mt-3'}>
                <Link to={CounterpartiesCreateContacts} target={'_blank'} className="btn btn-sm btn-outline-primary">
                  <i className="la la-plus"/>
                  Добавить нового клиента
                </Link>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant={'secondary'} onClick={handleClose}>
              Закрыть
            </Button>
            <Button onClick={saveOther} disabled={!selectedClientId}>
              Сохранить
            </Button>
          </Modal.Footer>
        </Modal>
      </Portlet>
    </BlockUi>
  );
};

export default MileCards;
